export const antdTheme = {
  token: {
    colorPrimary: '#0b5cab',
    colorInfo: '#0b5cab',
    colorSuccess: '#0d7a4f',
    colorError: '#b42318',
    colorWarning: '#c4a035',
    colorText: '#1a2b3c',
    colorTextSecondary: '#5a6f82',
    colorBgLayout: '#f4f9fd',
    colorBgContainer: '#ffffff',
    colorBorder: '#c5d7ea',
    borderRadius: 0,
    fontFamily: "'IBM Plex Sans', 'Segoe UI', system-ui, sans-serif",
    fontSize: 15,
    controlHeight: 40,
  },
  components: {
    Button: {
      borderRadius: 0,
      fontWeight: 600,
    },
    Table: {
      borderRadius: 0,
      headerBg: '#eef6fc',
    },
    Card: {
      borderRadius: 0,
    },
  },
};
